import { LoanCalculatorService, LoanCalculatorProvider, HttpService } from '@lk/api'

export const makeLoanCalculatorService = (http: HttpService, baseUrl: string) =>
  new LoanCalculatorService(new LoanCalculatorProvider(http, baseUrl))
